import React from 'react'
import {
  Collection,
  ForEachModel,
  useModelValue,
  ValueToCollection,
  WhenModelValue
} from '@morningtrain/react-resources'
import * as Filters from 'support/filters'
import * as Displays from 'support/displays'
import moment from 'moment'
import AvatarWrapper from 'ui/partials/AvatarWrapper'

export default function StaffList () {
  const startDate = useModelValue('start_at', null)
  const firstDay = moment(startDate).subtract(1, 'weeks').isoWeekday(6)
  const numberOfDays = 11
  const weekDays = []

  for (let day = 0; day < numberOfDays; day++) {
    weekDays.push(firstDay.clone().add(day, 'days'))
  }

  const getClassNameForColumn = i => {
    return [
      'day-column w-20 overflow-hidden flex-shrink-0 flex-grow flex items-center justify-center text-xs text-center border-t',
      'border-l border-gray-200',
      'py-2 flex flex-col space-y-2',
      (i === 2 || i === 9) ? 'thick-left-border' : '',
      i % 2 === 0 ? 'bg-highlight-100' : ''
    ].join(' ')
  }

  return (
    <Collection resourceName='shifts.schedule_slot' operationName='staff'>
      <Filters.StaticFilter name='$per_page' value='0' />
      <Filters.ModelValueFilter name='schedule_id' modelKey='id' />

      <div className='group space-12 mt-8 border border-gray-200 bg-white rounded-lg overflow-hidden'>
        <div className='overflow-x-auto'>
          <div className='row days-row flex'>
            <div className='w-56 flex-shrink-0' />
            {
              weekDays.map((day, i) => {
                return (
                  <div
                    className={[
                      'day w-20 flex-shrink-0 flex-grow h-20 text-center',
                      'border-l border-gray-200 flex items-center justify-center text-xs',
                      (i === 2 || i === 9) ? 'thick-left-border' : '',
                      i % 2 === 0 ? 'bg-highlight-100' : ''
                    ].join(' ')}
                  >
                    <div>
                      <div className='day-header day-of-week font-medium capitalize'>{day.format('dddd')}</div>
                      <div className='day-header date'>{day.format('DD-MM-YYYY')}</div>
                    </div>
                  </div>
                )
              })
            }
          </div>

          <div className='row'>
            <ForEachModel>
              <div className='row user-row flex'>
                <div className='user-column w-56 flex items-center flex-shrink-0 border-t border-gray-200 py-2 px-4'>
                  <div className='avatar-circle'>
                    <AvatarWrapper classes=''>
                      <Displays.Image name='user.avatar_url' />
                    </AvatarWrapper>
                  </div>
                  <div className='user-meta-column'>
                    <div className='font-medium text-sm truncate w-32'>
                      <Displays.Text name='user.name' />
                    </div>
                    <div className='text-gray-500 text-sm truncate w-32'>
                      <Displays.Text name='user.primary_bonus_role' />
                    </div>
                    <div className='text-gray-500 text-sm'>
                      <Displays.DurationFromSeconds name='total_for_week' />
                    </div>
                  </div>
                </div>
                <ValueToCollection name='collection'>
                  {weekDays.map((day, i) => {
                    return (
                      <div
                        className={getClassNameForColumn(i)}
                      >
                        <ForEachModel>
                          <WhenModelValue name='date' condition={day.format('YYYY-MM-DD')}>
                            <div>
                              <div>
                                <div>
                                  <Displays.DurationFromSeconds name='duration.duration' />
                                </div>
                                <div>
                                  <Displays.Time name='start_at' forceUTC /> - <Displays.Time name='end_at' forceUTC />
                                </div>
                                <div>
                                  <Displays.Text name='department_name' />
                                </div>
                                <div>
                                  <Displays.Enum name='category' enum='employment_type_category' />
                                </div>
                              </div>
                            </div>
                          </WhenModelValue>
                        </ForEachModel>
                      </div>
                    )
                  })}
                </ValueToCollection>
              </div>
            </ForEachModel>
          </div>
        </div>
      </div>
    </Collection>
  )
}
